const ns = "PASSES";
export const REQUEST = `${ns}_REQUEST`;
export const RECEIVE_LIST = `${ns}_RECEIVE_LIST`;
export const RECEIVE_PAGINATION = `${ns}_RECEIVE_PAGINATION`;
export const RECEIVE_STATS = `${ns}_RECEIVE_STATS`;
export const TOGGLE_MENU = `${ns}_TOGGLE_MENU`;
export const LANDED = `${ns}_LANDED`;
